import isMobile from "./is-mobile.js";

const pathname = function () {
    return location.pathname == "/index.php" ? "/" : location.pathname;
};

// $('.l-localNavi-list-item a').each(function(){
//   const $href = $(this).attr('href');
//   console.log($href + ":" + location.href);
//   if(location.href.match($href) && location.pathname != "/" && $href != "/") {
//     $(this).closest(".l-localNavi-list-item").addClass('is-current');
//   }
// });

//ローカルナビ
const localCurrent = function () {
    Array.from(document.querySelectorAll(".l-localNavi-list-item a")).forEach(
        (e) => {
            e.classList.remove("is-current");
            e.style = "";
            const url = new URL(e.href);
            const pathname = url.pathname;

            if (location.pathname.includes(pathname)) {
                const parent = e.closest(".l-localNavi-list-item");
                parent.classList.add("is-current");
                e.style.transition = "none";
            }
        }
    );

    // let count = 0;
    // $('.l-localNavi-list-item a').each(function(){
    //   const $href = $(this).attr('href').split('/');
    //   const $href_s = $href.slice(-2)[0];
    //   // console.log(location.href.match($href_s));
    //   // console.log($href_s);
    //   // console.log($href_s + ":" + location.pathname);
    //   if(location.pathname.match($href_s) && location.pathname != "/" && $href_s != "/") {
    //     $(this).css({
    //       "transition": "none"
    //     })
    //     $(this).closest(".l-localNavi-list-item").addClass('is-current');
    //     count += 1;
    //     // console.log(count);
    //   } else {
    //     $(this).removeAttr("style");
    //     $(this).closest(".l-localNavi-list-item").removeClass('is-current');
    //   }

    //   if(count >= 2) {
    //     $(".l-localNavi-list-item").eq(0).removeClass('is-current');
    //   }
    // });
};

// console.log(!($('.l-localNavi-list-item').hasClass('is-current')))
//レンダリングされたときにすでにis-currentがあれば実行しない
if (!$(".l-localNavi-list-item").hasClass("is-current")) {
    localCurrent();
}

const localCurrentPage = function () {
    $(".l-localNavi-list-item a").each(function () {
        const $href = $(this).attr("href").split("/");
        const $href_s = $href.slice(-1)[0];
        // console.log($href_s.match("#"));
        if ($href_s.match("#")) {
            if (
                location.href.match($href_s) &&
                location.pathname != "/" &&
                $href_s != "/"
            ) {
                $(this).css({
                    transition: "none",
                });
                $(this)
                    .closest(".l-localNavi-list-item")
                    .addClass("is-current");
            } else {
                $(this).removeAttr("style");
                $(this)
                    .closest(".l-localNavi-list-item")
                    .removeClass("is-current");
            }
        }
    });
};

localCurrentPage();

$(".l-localNavi-list-item a").on("click", function () {
    setTimeout(localCurrentPage, 300);
});

//グローバルナビ
const lang = ["en", "ch", "zh", "ko"];

const globalCurrent = function () {
    $(".l-header-navi-list__item a.l-header-navi-list__itemInner").each(
        function () {
            const $href = $(this).attr("href").split("/");
            //日本語以外か
            const $href_s = lang.includes($href[1]) ? $href[2] : $href[1];

            // console.log($href_s + ":" + location.href);
            if (
                location.href.match($href_s) &&
                location.pathname != "/" &&
                $href_s != "/"
            ) {
                $(this)
                    .closest(".l-header-navi-list__item")
                    .addClass("is-current");
            } else {
                $(this)
                    .closest(".l-header-navi-list__item")
                    .removeClass("is-current");
            }
        }
    );
};

globalCurrent();

$(".l-header-navi-list__item .l-header-navi-list__itemInner").on(
    "click",
    function () {
        setTimeout(globalCurrent, 300);
    }
);
